"use strict";
import { BaseCsvParser } from "./BaseCsvParser";
export class JobsCsvParser extends BaseCsvParser {
  /**
   * Get the list of required columns for jobs CSV
   * @returns Array of required column names
   */
  getRequiredColumns() {
    return ["location", "internal", "external", "state"];
  }
  /**
   * Validate if a job record has all required fields
   * @param record The record to validate
   * @returns True if the record is valid, false otherwise
   */
  validateRecord(record) {
    return !!(record["location"] && record["internal"] && record["external"] && record["state"]);
  }
  /**
   * Create a job object from the parsed CSV record
   * @param record The parsed CSV record
   * @param headers The CSV headers
   * @returns The job object with all headers as keys
   */
  createRecordObject(record, headers) {
    const jobObject = {};
    headers.forEach((header) => {
      jobObject[header] = record[header];
    });
    return jobObject;
  }
}
